import React from 'react';
import { useIntl } from 'react-intl';
import { Input } from 'semantic-ui-react';

const DictionaryInput = ({
  text,
  type,
  maxLength,
  onBlur,
  onChange,
  fluid,
  error,
}) => {
  const intl = useIntl();
  return (
    <Input
      error={error}
      fluid={fluid}
      className="aridhia-dictionary-input aridhia-is-edit-mode"
      value={text || ''}
      maxLength={maxLength}
      placeholder={intl.formatMessage({ id: `dataset.dictionary.${type}.placeholder` })}
      onChange={(e, { value }) => { onChange(value); }}
      {...(onBlur && { onBlur: (e) => { onBlur(e); } })}
    />
  );
};

export default DictionaryInput;
